import { FormControl } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import { Controller } from 'react-hook-form';
import { getStorePermissions } from 'v3/data/store/stores/actions';
import { EditIcon, IconStyled } from 'v3/shared/components/Inputs/InputFormController/styles';
import { InputFormControllerProps } from 'v3/shared/components/Inputs/InputFormController/types';
import { CheckedBoxIconStyled, ErrorMessage } from 'v3/shared/components/Inputs/styles/defaultStyles';
import { TextFieldStyles } from 'v3/shared/components/Inputs/styles/InputFormStyles';

export const InputFormController: React.FC<InputFormControllerProps> = ({
  formControl,
  formControlName,
  label,
  mask,
  customMask,
  placeholder,
  inputType,
  fullWidth = true,
  defaultValue,
  onKeyDown,
  disabled,
  readOnly,
  onChangeInput,
  onBlurInput,
  startAdornmentIcon,
  'data-testid': dataTestId,
  hasEditMode = false,
  showCheckbox = true,
  handleOpenChangeImeiModal,
  hasErrorField = true,
}) => {
  const { isMaster } = getStorePermissions();

  return (
    <Controller
      name={formControlName}
      control={formControl}
      render={({ field: { onChange, onBlur, ref, name, value }, fieldState: { error, invalid } }) => {
        const validated = value && !error && !invalid;

        return (
          <FormControl fullWidth={fullWidth}>
            <TextFieldStyles
              inputProps={{ 'data-testid': `${dataTestId}` }}
              fullWidth
              id={mask || label || ''}
              name={name}
              ref={ref}
              label={label}
              disabled={disabled}
              type={inputType || 'text'}
              error={!!error}
              autoComplete="off"
              autoCapitalize="none"
              onChange={(value) => {
                onChangeInput?.(value.target.value);
                onChange(value);
              }}
              onBlur={(value) => {
                onBlurInput?.(value.target.value);
                onBlur();
              }}
              value={value || defaultValue || ''}
              placeholder={placeholder ?? ''}
              onKeyDown={(event) => {
                if (event.key === 'Enter' && onKeyDown && validated) {
                  onKeyDown();
                }
              }}
              InputProps={{
                readOnly,
                inputComponent: customMask,
                startAdornment: startAdornmentIcon && (
                  <InputAdornment position="start">
                    <IconStyled as={startAdornmentIcon} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <>
                    {showCheckbox ? (
                      <InputAdornment position="end">{validated ? <CheckedBoxIconStyled /> : null}</InputAdornment>
                    ) : null}
                    {hasEditMode && isMaster ? <EditIcon onClick={handleOpenChangeImeiModal} /> : null}
                  </>
                ),
              }}
            />
            {hasErrorField && <ErrorMessage>{error?.message}</ErrorMessage>}
          </FormControl>
        );
      }}
    />
  );
};
